module.exports = __webpack_public_path__ + "static/img/content3.1015665c.png";